import React from 'react';
import { SortIndicator } from '../SortIndicator';
import { StyledTableHeader, TableHeadContainer } from './TableHeader.styles';
import { TableHeaderProps } from './types';

const TableHeader = ({
  sortMode,
  children,
  align = 'left',
  onClick,
  minWidth,
  disableSort = false,
  ...rest
}: TableHeaderProps) => {
  const isLeftOrCenter = align === 'left' || align === 'center';
  return (
    <StyledTableHeader justifyContent={align} minWidth={minWidth}>
      <TableHeadContainer {...rest} onClick={() => !disableSort && onClick()}>
        {!disableSort && align === 'right' && (
          <SortIndicator sortMode={sortMode} />
        )}
        {children}
        {!disableSort && isLeftOrCenter && (
          <SortIndicator sortMode={sortMode} />
        )}
      </TableHeadContainer>
    </StyledTableHeader>
  );
};
export default TableHeader;
